import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { ScriptService, Category } from '../../../../service/script.service';

export interface CategoriesDialogData {
  categories: string[];
}

export interface CategoriesDialogResult {
  categories: string[];
}

@Component({
  selector: 'app-categories-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatButtonModule
  ],
  templateUrl: './categories-dialog.component.html',
  styleUrl: './categories-dialog.component.less'
})
export class CategoriesDialogComponent {
  form: FormGroup;
  availableCategories: Category[] = [];

  constructor(
    private fb: FormBuilder,
    private scriptService: ScriptService,
    public dialogRef: MatDialogRef<CategoriesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CategoriesDialogData
  ) {
    this.form = this.fb.group({
      categories: [data.categories || []]
    });

    this.availableCategories = this.scriptService.categories || [];
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const result: CategoriesDialogResult = {
      categories: this.form.get('categories')?.value || []
    };
    this.dialogRef.close(result);
  }

  isCategorySelected(category: Category): boolean {
    const selected: string[] = this.form.get('categories')?.value || [];
    return selected.includes(category.name);
  }

  toggleCategory(category: Category): void {
    const currentCategories: string[] = this.form.get('categories')?.value || [];
    const index = currentCategories.indexOf(category.name);
    
    if (index > -1) {
      currentCategories.splice(index, 1);
    } else {
      currentCategories.push(category.name);
    }
    
    this.form.patchValue({ categories: currentCategories });
  }
}
